import { useCart } from "./CartContext";

/** Units of one product in the cart, summed over every variant and add-on line. */
export function useInCartCount(productId: string): number {
	const { items } = useCart();
	return items.reduce((n, i) => (i.productId === productId ? n + i.qty : n), 0);
}
